import React from "react";
import "./Dangers.sass";
import frens from "./../../../assets/images/dangers-frens.png";

export default function Dangers() {
  return (
    <div className="dangers">
      <div className="dangers-bg">
        <div className="dangers-text">
          If we allow him to succeed, he will put the <strong>Frens</strong> in
          a permanent virtual wage cage from which{" "}
          <strong> escape is impossible</strong>. Every corner of the Metaverse
          will encompass virtual Wage Cage prisons. <br />
          <br /> We will not have it! We are never selling our Cryptos! We’ve
          been through this before and will not fall for their tricks again.{" "}
        </div>
        <div className="dangers-image">
          <img src={frens} alt="frens in danger" />
        </div>
      </div>
    </div>
  );
}
